"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createRegistry = createRegistry;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

function createRegistry() {
  var registryStore = new _map.default();
  var registry = {
    register: function register(key, value) {
      if (registryStore.has(key)) {
        if (registryStore.get(key) !== value) {
          console.warn("Entry with key: ".concat(key, " it's already registered with a different value"));
        }

        return registry;
      }

      registryStore.set(key, value);
      return registry;
    },
    get: function get(key) {
      return registryStore.get(key);
    },
    clear: function clear() {
      return registryStore.clear();
    },
    keys: function keys() {
      return (0, _keys.default)(registryStore).call(registryStore);
    }
  };
  return registry;
}
